import React, { Component } from "react";

// Components
import { isNumber } from "../../helpers/helpers";

class ChurchPrice extends Component {
    constructor() {
        super();
    }

    render() {
        const {
            priceInfoNorwegian,
            adultPrice,
            childPrice,
            seniorPrice,
            studentPrice,
            familyPrice,
            familyPriceInfoNorwegian,
            groupPrice,
            groupMinimumCount,
        } = this.props.church;

        if (
            [
                priceInfoNorwegian,
                adultPrice,
                childPrice,
                seniorPrice,
                studentPrice,
                familyPrice,
                familyPriceInfoNorwegian,
                groupPrice,
                groupMinimumCount,
            ].every((prop) => prop === undefined || prop === null || prop === 0)
        ) {
            return null;
        }

        return (
            <div className="church-facts__wrapper church-facts__wrapper--mentollight">
                <div className="church-facts__inner">
                    <h3 className="church-facts__title">Inngang</h3>
                    {priceInfoNorwegian && (
                        <p>{priceInfoNorwegian}</p>
                    )}
                    {isNumber(adultPrice) && (
                        <p>
                            <strong>Voksen: </strong>
                            {adultPrice}
                        </p>
                    )}
                    {isNumber(childPrice) && (
                        <p>
                            <strong>Barn: </strong>
                            {childPrice}
                        </p>
                    )}
                    {isNumber(seniorPrice) && (
                        <p>
                            <strong>Honnør: </strong>
                            {seniorPrice}
                        </p>
                    )}
                    {isNumber(studentPrice) && (
                        <p>
                            <strong>Student: </strong>
                            {studentPrice}
                        </p>
                    )}
                    {isNumber(familyPrice) &&
                        familyPriceInfoNorwegian && (
                            <p>
                                <strong>Familie: </strong>
                                {familyPrice}
                                <br />
                                {familyPriceInfoNorwegian}
                            </p>
                        )}
                    {isNumber(groupPrice) && (
                        <p>
                            <strong>Gruppe: </strong>
                            {groupPrice}
                        </p>
                    )}
                    {isNumber(groupMinimumCount) && (
                        <p>
                            <strong>Minimum antall: </strong>
                            {groupMinimumCount}
                        </p>
                    )}
                </div>
            </div>
        );
    }
}

export default ChurchPrice;



// WEBPACK FOOTER //
// ./src/components/Price/index.js